<script>
import { sync } from 'vuex-pathify'

export default {
  computed: {
    loadingIsLoading: sync('LoadingModule/isLoading')
  },
  methods: {
    loadingDismiss () {
      this.loadingIsLoading = false
    },
    loadingDisplay () {
      this.loadingIsLoading = true
    }
  }
}
</script>
